import React, { useMemo, useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { Search, SlidersHorizontal } from "lucide-react";
import api from "../lib/api";
import TourCard from "../components/TourCard";
import Footer from "../components/Footer";
import { Input } from "../components/ui/input";
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from "../components/ui/select";

export default function Tours() {
  const [params, setParams] = useSearchParams();
  const [q, setQ] = useState(params.get("q") || params.get("location") || "");
  const [sort, setSort] = useState("popular");
  const [tours, setTours] = useState([]);

  useEffect(() => {
    api.get("/tours").then((res) => setTours(res.data)).catch(() => {});
  }, []);

  const filtered = useMemo(() => {
    let list = [...tours];
    const term = q.trim().toLowerCase();
    if (term) {
      list = list.filter((t) =>
        [t.title, t.location, t.country, t.short, t.tagline].join(" ").toLowerCase().includes(term)
      );
    }
    if (sort === "low") list.sort((a, b) => a.price - b.price);
    if (sort === "high") list.sort((a, b) => b.price - a.price);
    return list;
  }, [q, sort, tours]);

  return (
    <div className="bg-white min-h-screen">
      <section className="hero-dark pt-28 pb-14">
        <div className="max-w-7xl mx-auto px-5">
          <h1 className="text-4xl md:text-5xl font-bold text-white">Explore All Tours</h1>
          <p className="mt-3 text-slate-300">Curated group departures across Asia and beyond.</p>
          <div className="mt-6 bg-white rounded-2xl p-2 flex flex-col sm:flex-row gap-2 max-w-2xl shadow-2xl">
            <div className="flex items-center gap-2 flex-1 px-3">
              <Search className="w-5 h-5 text-slate-400" />
              <Input value={q} onChange={(e) => { setQ(e.target.value); setParams({}); }}
                placeholder="Search destination or theme..." className="border-0 shadow-none focus-visible:ring-0 px-0" />
            </div>
          </div>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-5 py-12">
        <div className="flex items-center justify-between mb-6">
          <p className="text-sm text-slate-500">{filtered.length} tour{filtered.length !== 1 ? "s" : ""} found</p>
          <div className="flex items-center gap-2">
            <SlidersHorizontal className="w-4 h-4 text-slate-500" />
            <Select value={sort} onValueChange={setSort}>
              <SelectTrigger className="w-44"><SelectValue /></SelectTrigger>
              <SelectContent>
                <SelectItem value="popular">Most Popular</SelectItem>
                <SelectItem value="low">Price: Low to High</SelectItem>
                <SelectItem value="high">Price: High to Low</SelectItem>
              </SelectContent>
            </Select>
          </div>
        </div>
        {filtered.length === 0 ? (
          <div className="text-center py-20 text-slate-500">No tours match your search. Try another destination.</div>
        ) : (
          <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
            {filtered.map((t) => <TourCard key={t.id} tour={t} />)}
          </div>
        )}
      </section>
      <Footer />
    </div>
  );
}
